import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const AboutSection = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-cream"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <p className="text-xs uppercase tracking-[0.2em] text-gold font-sans font-semibold mb-4">
              Le Fondateur
            </p>
            <h2
              className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal tracking-tight text-forest mb-6"
              data-testid="about-headline"
            >
              Un Parcours Différent vers la Forêt
            </h2>
            <div className="section-divider mb-8" />

            <div className="space-y-6 font-sans text-base md:text-lg text-gray-700 leading-relaxed">
              <p>
                Avec plus de <strong className="text-forest">10 ans d'expérience en assemblage foncier et
                promotion immobilière</strong>, j'ai appris à naviguer dans des structures
                de propriété complexes, à négocier avec des parties prenantes diverses
                et à créer de la valeur par un travail patient et méthodique.
              </p>
              <p>
                J'applique désormais ces compétences à un terrain différent—<strong className="text-forest">le
                foncier rural et forestier</strong>. Les défis sont similaires : morcellement forestier,
                problèmes de succession, complexité administrative. Les solutions de
                remembrement et regroupement de parcelles exigent la même rigueur.
              </p>
              <p>
                <strong className="text-forest">Ma mission</strong> est de rendre les forêts lisibles, cohérentes
                et transmissibles—transformer des parcelles dispersées en actifs
                organisés et durables pour les générations futures.
              </p>
            </div>

            <div className="mt-8 p-6 bg-bone">
              <p className="font-sans text-sm text-gray-600 mb-2">
                <strong className="text-forest">Titulaire Carte T</strong> — Professionnel de l'Immobilier Réglementé
              </p>
              <p className="font-sans text-sm text-gray-600">
                <MapPin className="inline w-4 h-4 mr-1 text-gold" />
                Basé en Charente / Nouvelle-Aquitaine — France entière sur demande
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1686577184216-6fac0767080c?q=80&w=2000&auto=format&fit=crop"
                alt="Chemin forestier en Charente, zone d'intervention de Sylva Invest"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-gold" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
